import { CategoriaServicosCor } from '../models/categoria-servicos.model';

const ICONES = 'assets/images/icones-servicos';

/**
 * Chave editorial do ícone da categoria → SVG do card.
 *
 * Espelha, chave por chave, o `ICONES_CATEGORIA` do sai-adm-web (`servicos.model.ts`). Ao
 * acrescentar uma opção lá, acrescente aqui: chave ausente cai no ícone padrão de quem
 * chamou, o que degrada bem, mas mostra o ícone errado.
 *
 * ⚠️ **Nunca** monte `icon-${chave}.svg`: uma chave nova no adm viraria um 404 silencioso e
 * um card sem ícone.
 */
const SVG_POR_CHAVE: ReadonlyMap<string, string> = new Map([
  ['saude', `${ICONES}/icon-saude.svg`],
  ['educacao', `${ICONES}/icon-educacao.svg`],
  ['social', `${ICONES}/icon-assistencia-social.svg`],
  ['obras', `${ICONES}/icon-urbanismo-obras.svg`],
  ['financas', `${ICONES}/icon-financas.svg`],
  ['transporte', `${ICONES}/icon-transporte-mobilidade.svg`],
  ['ambiente', `${ICONES}/icon-meio-ambiente.svg`],
  ['cultura', `${ICONES}/icon-cultura-esporte-turismo.svg`],
  ['seguranca', `${ICONES}/icon-seguranca-defesa-civil.svg`],
]);

/**
 * O "Azul Institucional" é o padrão do formulário de categoria do adm (`CORES_TEMA[0]`), e
 * por isso também o destino de um hex fora da paleta.
 */
const COR_PADRAO: CategoriaServicosCor = 'azul';

/**
 * Hex da cor tema da categoria → nome da paleta do card (`data-categoria-servicos-cor`).
 *
 * Espelha o `CORES_TEMA` do sai-adm-web. A coluna é texto livre no banco — o back-end
 * valida o formato do hex, não a paleta —, então todo valor fora daqui cai em `azul`.
 */
const COR_POR_HEX: ReadonlyMap<string, CategoriaServicosCor> = new Map([
  ['#1E4775', 'azul'],
  ['#16A34A', 'verde'],
  ['#FF9900', 'laranja'],
  ['#7E22CE', 'roxo'],
  ['#DC2626', 'vermelho'],
  ['#6B7280', 'cinza'],
]);

/**
 * O SVG do card para a chave editorial da categoria (`desIconeCtg`).
 *
 * O padrão é de quem chama porque cada tela tem o seu: um card de categoria qualquer com o
 * ícone de "serviços digitais" diria o que a categoria não é.
 */
export function svgDaCategoria(chave: string | null | undefined, padrao: string): string {
  return SVG_POR_CHAVE.get((chave ?? '').trim().toLowerCase()) ?? padrao;
}

/**
 * O nome da paleta do card para a cor tema da categoria (`desCorTemaCtg`).
 *
 * Não confundir com a função local `corDaCategoria` de `todos-servicos.component.ts`: aquela
 * **sorteia** uma cor a partir do id, para os favoritos; esta traduz a cor cadastrada no adm.
 */
export function corDaCategoria(hex: string | null | undefined): CategoriaServicosCor {
  return COR_POR_HEX.get((hex ?? '').trim().toUpperCase()) ?? COR_PADRAO;
}
